import { z } from 'zod';

const fontStyleSchema = z.object({
    fontFamily: z.string(),
    fontSize: z.string(),
    fontWeight: z.string(),
    letterSpacing: z.string().optional(),
    lineHeight: z.string(),
    textCase: z.string().optional(),
});

const shadowItemSchema = z.object({
    blur: z.string(),
    color: z.string(),
    spread: z.string(),
    type: z.enum(['dropShadow', 'innerShadow']),
    x: z.string(),
    y: z.string(),
});

const shadowSizeSchema = shadowItemSchema.array();

const headingLevelSchema = z.object({
    medium: fontStyleSchema,
    regular: fontStyleSchema,
});

const bodySizeSchema = z.object({
    medium: fontStyleSchema,
    regular: fontStyleSchema,
    semibold: fontStyleSchema,
});

const captionSizeSchema = z.object({
    medium: fontStyleSchema,
    regular: fontStyleSchema,
    semibold: fontStyleSchema,
});

const colorScaleSchema = z.object({
    100: z.string().optional().default(''),
    200: z.string().optional().default(''),
    25: z.string().optional().default(''),
    300: z.string().optional().default(''),
    400: z.string().optional().default(''),
    50: z.string().optional().default(''),
    500: z.string().optional().default(''),
    600: z.string().optional().default(''),
    700: z.string().optional().default(''),
    800: z.string().optional().default(''),
    900: z.string().optional().default(''),
    950: z.string().optional().default(''),
});

export const tokenSchema = z.object({
    color: z.object({
        black: colorScaleSchema,
        error: colorScaleSchema,
        gray: colorScaleSchema,
        orange: colorScaleSchema,
        success: colorScaleSchema,
        warning: colorScaleSchema,
        white: colorScaleSchema,
    }),
    radius: z.record(z.string(), z.string()),
    shadow: z.object({
        l: shadowSizeSchema,
        m: shadowSizeSchema,
        s: shadowSizeSchema,
    }),
    spacing: z.record(z.string(), z.string()),
    typography: z.object({
        body: z.object({
            L: bodySizeSchema,
            M: bodySizeSchema,
            S: bodySizeSchema,
            XS: bodySizeSchema,
            XXS: bodySizeSchema,
        }),
        caption: z.object({
            S: captionSizeSchema,
            XS: captionSizeSchema,
        }),
        headline: z.object({
            h1: headingLevelSchema,
            h2: headingLevelSchema,
            h3: headingLevelSchema,
            h4: headingLevelSchema,
        }),
    }),
});

export type Tokens = z.infer<typeof tokenSchema>;
